import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  HostBinding,
} from '@angular/core';
import { Router } from '@angular/router';
import { ApiservicesService } from 'src/app/services/apiservices.service';
@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit, OnDestroy, OnChanges {
  // constructor(private apiservice: ApiservicesService, public router: Router) {}

  @Input() items: any[] = [];
  @Input() cardsToShow: number = 3;
  @Input() animationDurationMs: number = 500;
  @Input() autoplay: boolean = false;
  @Input() autoplayIntervalMs: number = 5000;
  @Output() cardClicked = new EventEmitter<any>();

  public currentIndex = 0;
  public transformValue = '';
  private autoplayIntervalId: any;
  public dotsArray: any[] = [];

  @HostBinding('style.--cards-to-show')
  get hostCardsToShow() {
    return this.cardsToShow;
  }

  @HostBinding('style.--transition-duration')
  get hostTransitionDuration() {
    return `${this.animationDurationMs}ms`;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['items'] || changes['cardsToShow'] || changes['autoplay']) {
      this.initializeCarousel();
    }
  }

  ngOnInit(): void {
    this.initializeCarousel();
  }

  ngOnDestroy(): void {
    this.stopAutoplay();
  }

  private initializeCarousel(): void {
    console.log('CarouselComponent initialized with items:', this.items);

    this.stopAutoplay();
    this.currentIndex = 0;

    const dotsCount =
      this.items.length > this.cardsToShow
        ? this.items.length - this.cardsToShow + 1
        : 1;
    this.dotsArray = new Array(dotsCount);

    this.updateTransform();

    if (this.autoplay && this.canNavigate()) {
      this.startAutoplay();
    }
  }

  public next(): void {
    if (this.isNextDisabled()) return;
    this.currentIndex++;
    this.updateTransform();
  }

  public prev(): void {
    if (this.isPrevDisabled()) return;
    this.currentIndex--;
    this.updateTransform();
  }

  public goTo(index: number): void {
    this.currentIndex = index;
    this.updateTransform();
  }

  private updateTransform(): void {
    const offset = -this.currentIndex * (100 / this.cardsToShow);
    this.transformValue = `translateX(${offset}%)`;
  }

  public isPrevDisabled(): boolean {
    return this.currentIndex === 0;
  }

  public isNextDisabled(): boolean {
    return this.currentIndex >= this.items.length - this.cardsToShow;
  }

  public canNavigate(): boolean {
    return this.items.length > this.cardsToShow;
  }

  public isActiveDot(index: number): boolean {
    return this.currentIndex === index;
  }

  public startAutoplay(): void {
    if (!this.autoplay || !this.canNavigate()) {
      return;
    }
    this.stopAutoplay();
    this.autoplayIntervalId = setInterval(() => {
      if (this.isNextDisabled()) {
        this.goTo(0);
      } else {
        this.next();
      }
    }, this.autoplayIntervalMs);
  }

  public stopAutoplay(): void {
    if (this.autoplayIntervalId) {
      clearInterval(this.autoplayIntervalId);
    }
  }

  public viewLesson(item: any): void {
    this.cardClicked.emit(item);
  }
}
